import React, { useState } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import {
  DataValue,
  SectionLabel,
  DisplayFlex,
} from "../../../../../../CommonComponents/commonStyles";
import {
  ButtonContainer,
  TopDivider,
  ModalHeaderSubText,
  AlertAddress,
  CustomPrimaryButtonWrap
} from "./style";
import {
  UnderlyingContent,
  CustomModal,
  ModalHeading,
  CardPopContainer,
} from "../../style";
import PrintButton from "../../../../../../CommonComponents/PrintButton/PrintButton";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import ScheduleSection from "./ScheduleSection";
import AgreementSection from "./AgreementSection";
import { GeneralButton } from "../../../../../../CommonComponents/Commons/commonComponents";

export const printButtonRender = (renderPrint, id='') => (
  <PrintButton id={`${id}btnPrint`} className="ml-auto">
    {renderPrint}
  </PrintButton>
);

export const getAgreementSection = ({
  history,
  agreements,
  grantActivityClick,
  grantDetailsHandler,
}) => (
  <Col lg={24} md={24} xs={24}>
    <AgreementSection
      data-test="agreement-section"
      agreements={agreements}
      history={history}
      grantActivityClick={grantActivityClick}
      grantDetailsHandler={(id) => grantDetailsHandler(id, "agreement")}
    />
  </Col>
);

export const getScheduleSection = ({
  history,
  schedule,
  grantActivityClick,
  grantDetailsHandler,
}) => (
  <Col lg={24} md={24} xs={24}>
    <ScheduleSection
      data-test="schedule-section"
      schedule={schedule}
      history={history}
      grantActivityClick={grantActivityClick}
      grantDetailsHandler={(id) => grantDetailsHandler(id, "recurring")}
    />
  </Col>
);

export const getFooter = ({
  singleCta,
  onCancel,
  ctaLabel,
  primaryCta,
  primaryCtaLabel,
  secondaryCtaLabel,
}) => {
  if (singleCta) {
    return (
      <ButtonContainer>
        <GeneralButton
          key="Close"
          onClick={onCancel}
          id="btnCancel"
          type="functional"
          text={ctaLabel}
          width="100%"
          mobWidth="100%"
          inverted
        />
      </ButtonContainer>
    );
  }

  return (
    <div>
      <CustomPrimaryButtonWrap>
        <GeneralButton
          id="btnYesMakeANewGrant"
          key="Close"
          onClick={primaryCta}
          type="functional"
          text={primaryCtaLabel}
          width="100%"
          mobWidth="100%"
        />
      </CustomPrimaryButtonWrap>
      <UnderlyingContent id="btnNoTakemeBack" onClick={onCancel}>
        {secondaryCtaLabel}
      </UnderlyingContent>
    </div>
  );
};

export const getTitle = (popupTitle, popupDesc) => (
  <>
    {popupTitle && <ModalHeading>{popupTitle}</ModalHeading>}
    {popupDesc && <ModalHeaderSubText>{popupDesc}</ModalHeaderSubText>}
  </>
);

function GrantPopup(props) {
  const [showAddress, toggleShowAddress] = useState(false);

  const toggleAddress = () => toggleShowAddress(!showAddress);
  return (
    <CustomModal
      title={[getTitle(props.popupTitle, props.popupDesc)]}
      visible={props.show}
      onCancel={props.onCancel}
      footer={[
        getFooter({
          singleCta: props.singleCta,
          onCancel: props.onCancel,
          ctaLabel: props.ctaLabel,
          primaryCta: props.primaryCta,
          primaryCtaLabel: props.primaryCtaLabel,
          secondaryCtaLabel: props.secondaryCtaLabel,
        }),
      ]}
      width="895px"
      padding="20px 0"
    >
      <Row>
        <Col lg={24} md={0} xs={0}>
          <Row>
            <Col>
              <DataValue>{props.grantName}</DataValue>
              <SectionLabel className="mt-10">
                <DisplayFlex>
                  <AlertAddress>
                    {props.grantAddress}
                    {" | EIN: "}
                    {props.grantEin}
                  </AlertAddress>
                  {printButtonRender(props.renderPrint, 'ein')}
                </DisplayFlex>
              </SectionLabel>
            </Col>
          </Row>
          {props.loading ? (
            <Preloader />
          ) : (
            <>
              {props.renderDesktop}
              {props.schedule &&
                getScheduleSection({
                  history: props.history,
                  schedule: props.schedule,
                  grantActivityClick: props.grantActivityClick,
                  grantDetailsHandler: props.grantDetailsHandler,
                })}
              {props.agreements &&
                getAgreementSection({
                  history: props.history,
                  agreements: props.agreements,
                  grantActivityClick: props.grantActivityClick,
                  grantDetailsHandler: props.grantDetailsHandler,
                })}
            </>
          )}
        </Col>
        <Col lg={0} md={24} xs={24}>
          <Row>
            <Col lg={0} md={24} xs={24}>
              <DataValue>{props.grantName}</DataValue>
              {showAddress ? (
                <SectionLabel className="mt-10">
                  <DisplayFlex>
                    {props.grantAddress} <br />
                    {"EIN: "}
                    {props.grantEin}
                  </DisplayFlex>
                </SectionLabel>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <Row className="mt-10">
            <Col lg={0} md={24} xs={24}>
              <DisplayFlex>
                <UnderlyingContent
                  data-test="underlying-link"
                  id="anrIsAddressShow"
                  onClick={toggleAddress}
                >
                  {showAddress ? "Hide Address" : "Show Address"}
                </UnderlyingContent>
                {printButtonRender(props.renderPrint, 'address')}
              </DisplayFlex>
            </Col>
          </Row>
          <TopDivider />
          <CardPopContainer>
            {props.loading ? (
              <Preloader />
            ) : (
              <>
                {props.renderMobile}
                {props.schedule &&
                  getScheduleSection({
                    history: props.history,
                    schedule: props.schedule,
                    grantActivityClick: props.grantActivityClick,
                    grantDetailsHandler: props.grantDetailsHandler,
                  })}
                {props.agreements &&
                  getAgreementSection({
                    history: props.history,
                    agreements: props.agreements,
                    grantActivityClick: props.grantActivityClick,
                    grantDetailsHandler: props.grantDetailsHandler,
                  })}
              </>
            )}
          </CardPopContainer>
        </Col>
      </Row>
    </CustomModal>
  );
}

GrantPopup.propTypes = {
  agreements: PropTypes.array,
  ctaLabel: PropTypes.string,
  grantActivityClick: PropTypes.func,
  grantAddress: PropTypes.string,
  grantDetailsHandler: PropTypes.func,
  grantEin: PropTypes.string,
  grantName: PropTypes.string,
  history: PropTypes.bool,
  loading: PropTypes.bool,
  onCancel: PropTypes.func,
  popupTitle: PropTypes.string,
  renderDesktop: PropTypes.elementType,
  renderMobile: PropTypes.arrayOf(PropTypes.elementType),
  renderPrint: PropTypes.elementType,
  schedule: PropTypes.array,
  show: PropTypes.bool,
  singleCta: PropTypes.bool,
};

export default GrantPopup;
